import { vservice } from '@niknevis/vue-modules'
import { AdminNoteService } from '@/modules/common/note/services/admin-note.service'
import { NoteRequestModel } from '@/modules/common/note/models/note-request.model'

@vservice()
export class AdminNoteUpdateUseCase {
  isLoading = false
  isSuccess = false

  constructor(
    private readonly service: AdminNoteService
  ) {
  }

  execute(noteId: number, data: NoteRequestModel): Promise<any> {
    return this.service.update(noteId, data)
      .onStart(progress => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

}
